import * as Types from 'features/frontoffice/actions/types';
import * as CustomTypes from '../actions/types';
import axios from 'axios';
import { AppConfig } from 'AppConfig';
import * as AppActionTypes from 'store/actions/appstate';
import { requestWithTenantSwitchRetry } from 'networking/tenantSwitchRetry';

export const fetchCustomReports = () => {
  return (dispatch) => {
    dispatch({
      type: Types.FETCH_REPORT_CUSTOM_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.get(AppConfig.FO_INITIAL_URL + `/report/custom`)
    )
      .then((m) => {
        const response = m.data;
        dispatch({
          type: Types.FETCH_REPORT_CUSTOM_SUCCESS,
          payload: response || null
        });
      })
      .catch((err) => {
        dispatch({
          type: Types.FETCH_REPORT_CUSTOM_FAILURE,
          payload: 'Could not find custom reports.'
        });
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: 'Could not find custom reports.'
        });
      });
  };
};

export const setCurrentMenuItem = (item) => {
  return (dispatch) => {
    dispatch({
      type: CustomTypes.SET_CURRENT_SELECTED_MENU,
      data: item
    });
  };
};

export const setCurrentTags = (tags) => {
  return (dispatch) => {
    dispatch({
      type: CustomTypes.SET_CURRENT_SELECTED_MENU,
      data: tags
    });
  };
};

export const fetchCustomReportWorkbooks = () => {
  return (dispatch) => {
    dispatch({
      type: CustomTypes.SET_CUSTOM_WORKBOOKS_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.post(AppConfig.FO_INITIAL_URL + `/tbl/project-name`, {
        projectName: 'Custom Reports'
      })
    )
      .then((m) => {
        const response = m.data;
        dispatch({
          type: CustomTypes.SET_CUSTOM_WORKBOOKS,
          data: response
        })
      })
      .catch((err) => {
        console.log('could not get workbooks: ', err);
        dispatch({
          type: CustomTypes.SET_CUSTOM_WORKBOOKS,
          data: []
        });
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: 'Could not find custom reports.'
        });
      });
  };
};

export const fetchCustomReportProjects = () => {
  return (dispatch) => {
    dispatch({
      type: CustomTypes.SET_CUSTOM_PROJECTS_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.get(AppConfig.FO_INITIAL_URL + `/tbl/custom-projects`)
    )
    .then((m) => {
      dispatch({
        type: CustomTypes.SET_CUSTOM_PROJECTS,
        data: m.data
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: CustomTypes.SET_CUSTOM_PROJECTS,
        data: []
      });
    });
  }
}

export const fetchAdHocReportsForCustom = () => {
  return (dispatch) => {
    dispatch({
      type: CustomTypes.FETCH_ADHOC_REPORTS_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.get(AppConfig.FO_INITIAL_URL + '/saved-reports/')
    )
      .then((res) => {
        dispatch({
          type: CustomTypes.FETCH_ADHOC_REPORTS_SUCCESS,
          payload: res.data
        });
      })
      .catch((err) => {
        dispatch({
          type: CustomTypes.FETCH_ADHOC_REPORTS_FAILURE,
          payload: 'Could not fetch ad-hoc reports.'
        });
      });
  };
};